import $ from "jquery";
import { LocaleProvider } from "./src/i18n/locale-provider";
import Layout from "./src/components/layout";
import React from "react";

// Make jQuery available globally first
window.jQuery = $;
window.$ = $;

// Load ripples plugin after jQuery is available
const loadRipples = async () => {
  try {
    // Try dynamic import first
    await import("jquery.ripples");
    console.log("jQuery ripples plugin loaded via dynamic import");
  } catch (error) {
    try {
      // Fallback to require
      require("jquery.ripples");
      console.log("jQuery ripples plugin loaded via require");
    } catch (requireError) {
      console.error("Failed to load jquery.ripples:", requireError);
    }
  }
};

export const onClientEntry = () => {
  // Load the plugin
  loadRipples();

  // Check if plugin is available
  setTimeout(() => {
    if ($.fn && $.fn.ripples) {
      console.log("jQuery ripples plugin loaded successfully");
    } else {
      console.warn("jQuery ripples plugin not loaded properly");
    }
  }, 100);
};

// Wrap all pages with the Layout component
export const wrapPageElement = ({ element, props }) => {
  return (
    <LocaleProvider {...props}>
      <Layout>{element}</Layout>
      {/* <CookieConsent /> */}
    </LocaleProvider>
  );
};
